import fetcher from '../client';

export type NavigationPageMatch = {
  title: string;
  href: string;
  sku: string; // required for compatibility with QuickSearchProduct type
  thumbnail: null;
};

export type NavigationSearchResult = {
  count: number;
  keyword: string;
  products: NavigationPageMatch[];
};

export async function navigationSearch(
  query: { locale: string; keyword: string },
  init?: RequestInit
): Promise<NavigationSearchResult> {
  return await fetcher.get('/navigation/search', query, init);
}
